import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.customerHierarchy.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.customerHierarchy.actionsLoading;
export const getItems = (state:RootState) => state.customerHierarchy.items;
export const getItemsSelect = (state:RootState) => state.customerHierarchy.dropDownItems;
export const getItemsCount = (state:RootState) => state.customerHierarchy.itemsCount;
export const getItemForEdit = (state:RootState) => state.customerHierarchy.itemForEdit;
export const getError = (state:RootState) => state.customerHierarchy.error;
export const getErrorAction = (state:RootState) => state.customerHierarchy.errorAction;
export const getValidationErrors = (state: RootState) => state.customerHierarchy.validationErrors;
